(() => {
  const sourceSelector =
    '.header__desktop .parent_collections .flagship-item';
  const targetSelector = '[data-kw-mobile-flagship]';
  const linksSelector = '[data-kw-mobile-flagship-links]';

  function syncMobileFlagshipCollections() {
    const sourceLinks = Array.from(document.querySelectorAll(sourceSelector));

    document.querySelectorAll(targetSelector).forEach((target) => {
      const links = target.querySelector(linksSelector);

      if (!links) return;

      links.replaceChildren();

      sourceLinks.forEach((sourceLink) => {
        const title = sourceLink
          .querySelector('.flagship-item__title')
          ?.textContent.trim();
        const href = sourceLink.getAttribute('href');

        if (!title || !href) return;

        const mobileLink = document.createElement('a');
        mobileLink.className = 'kw-mobile-accordion__link';
        mobileLink.href = href;
        mobileLink.textContent = title;
        links.appendChild(mobileLink);
      });

      target.hidden = links.childElementCount === 0;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      syncMobileFlagshipCollections,
      { once: true }
    );
  } else {
    syncMobileFlagshipCollections();
  }

  if (!window.kwMobileFlagshipCollectionsInitialized) {
    window.kwMobileFlagshipCollectionsInitialized = true;
    document.addEventListener(
      'shopify:section:load',
      syncMobileFlagshipCollections
    );
  }
})();
